<div class="mfunsPlayer-danmuku-edit-mask">
  <div class="mfunsPlayer-danmaku-sendBar">
    <div class="mfunsPlayer-danmuku-edit-cancel"></div>
    <input class="mfunsPlayer-danmaku-text" type="text" placeholder="喵御宅Mfuns,发射(。゜ω゜)ノ!" />
    <div class="mfunsPlayer-danmaku-emit"></div>
  </div>
  <div class="mfunsPlayer-danmaku-edit-size">
    <label>弹幕字号</label>
    <ul class="mfunsPlayer-danmaku-edit-options">
      <li class="mfunsPlayer-danmaku-edit-item size" data-size="12">超小</li>
      <li class="mfunsPlayer-danmaku-edit-item size" data-size="16">小</li>
      <li class="mfunsPlayer-danmaku-edit-item size focus" data-size="18">标准</li>
      <li class="mfunsPlayer-danmaku-edit-item size" data-size="24">大</li>
      <li class="mfunsPlayer-danmaku-edit-item size" data-size="34">超大</li>
      <li class="mfunsPlayer-danmaku-edit-item size" data-size="42">特大</li>
    </ul>
  </div>
  <div class="mfunsPlayer-danmaku-edit-type">
    <label>弹幕类型</label>
    <ul class="mfunsPlayer-danmaku-edit-options">
      <li class="mfunsPlayer-danmaku-edit-item type" data-type="top">顶部</li>
      <li class="mfunsPlayer-danmaku-edit-item type focus" data-type="right">滚动</li>
      <li class="mfunsPlayer-danmaku-edit-item type" data-type="bottom">底部</li>
      <li class="mfunsPlayer-danmaku-edit-item type" data-type="left">逆向</li>
    </ul>
  </div>
  <div class="mfunsPlayer-danmaku-edit-color">
    <label>弹幕颜色</label>
    <ul class="mfunsPlayer-danmaku-edit-options">
      {{ each $data }}
      <li class="mfunsPlayer-danmaku-edit-item color" style="background:{{ $value }}" data-color="{{ $value }}"></li>
      {{ /each }}
    </ul>
  </div>
</div>
